module.exports = __webpack_public_path__ + "img/convert.d95a6a58.png";